// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listWrapper__a79 {
  width: calc(32 * (var(--ring-unit)));
  border-radius: var(--ring-border-radius);
  border: 1px solid var(--ring-line-color);
  background-color: var(--ring-sidebar-background-color);
}

.group__c2e {
  width: 100%;

  .groupName__c0e {
    padding: calc(var(--ring-unit) * 1.25) calc(var(--ring-unit) * 1.5);

    color: var(--ring-secondary-color);
  }

  .groupContent__d10 {
    display: flex;
    flex-direction: column;
  }
}

.item__b78 {
  position: relative;
  box-sizing: border-box;

  display: flex;
  align-items: center;

  min-height: calc(6 * (var(--ring-unit)));
  width: 100%;

  padding: calc(0.75 * var(--ring-unit)) calc(2 * var(--ring-unit));

  background-color: transparent;
  transition: background-color var(--ring-fast-ease);

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -1px;
    width: 2px;
    height: 100%;
    background-color: transparent;
    transition: background-color var(--ring-fast-ease);
  }

  &.interactive__d18 {
    cursor: pointer;
  }

  &.primary__f67 {
    &.interactive__d18:hover {
      background-color: var(--ring-selected-background-color);
    }

    &.selected__c64 {
      background-color: var(--ring-selected-background-color);

      &:before {
        background-color: var(--ring-action-link-color);
      }
    }
  }

  &.secondary__a0a {
    &.interactive__d18:hover {
      background-color: var(--ring-border-disabled-color);
    }

    &.selected__c64 {
      background-color: var(--ring-border-disabled-color);

      &:before {
        background-color: var(--ring-borders-color);
      }
    }
  }
}

.listWrapper__a79 > .group__c2e {
  &:last-child {
    border-bottom-left-radius: var(--ring-border-radius);
    border-bottom-right-radius: var(--ring-border-radius);
  }
}

.listWrapper__a79 > .item__b78 {
  &:first-child {
    border-top-left-radius: var(--ring-border-radius);
    border-top-right-radius: var(--ring-border-radius);

    padding-top: calc(1.5 * var(--ring-unit));

    &:before {
      border-top-left-radius: var(--ring-border-radius);
    }
  }

  &:last-child {
    border-bottom-left-radius: var(--ring-border-radius);
    border-bottom-right-radius: var(--ring-border-radius);

    padding-bottom: calc(1.5 * var(--ring-unit));

    &:before {
      border-bottom-left-radius: var(--ring-border-radius);
    }
  }
}

.group__c2e:last-child .groupContent__d10 > .item__b78 {
  &:last-child {
    border-bottom-left-radius: var(--ring-border-radius);
    border-bottom-right-radius: var(--ring-border-radius);

    padding-bottom: calc(1.5 * var(--ring-unit));

    &:before {
      border-bottom-left-radius: var(--ring-border-radius);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/selectable-list/selectable-list.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA;EACE,WAAW;;EAEX;IACE,mEAAmE;;IAEnE,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;;EAEtB,aAAa;EACb,mBAAmB;;EAEnB,wCAAwC;EACxC,WAAW;;EAEX,iEAAiE;;EAEjE,6BAA6B;EAC7B,kDAAkD;;EAElD;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,UAAU;IACV,YAAY;IACZ,6BAA6B;IAC7B,kDAAkD;EACpD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,uDAAuD;IACzD;;IAEA;MACE,uDAAuD;;MAEvD;QACE,+CAA+C;MACjD;IACF;EACF;;EAEA;IACE;MACE,mDAAmD;IACrD;;IAEA;MACE,mDAAmD;;MAEnD;QACE,2CAA2C;MAC7C;IACF;EACF;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,iDAAiD;IACjD,kDAAkD;;IAElD,yCAAyC;;IAEzC;MACE,iDAAiD;IACnD;EACF;;EAEA;IACE,oDAAoD;IACpD,qDAAqD;;IAErD,4CAA4C;;IAE5C;MACE,oDAAoD;IACtD;EACF;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD,qDAAqD;;IAErD,4CAA4C;;IAE5C;MACE,oDAAoD;IACtD;EACF;AACF","sourcesContent":[".listWrapper {\n  width: calc(32 * (var(--ring-unit)));\n  border-radius: var(--ring-border-radius);\n  border: 1px solid var(--ring-line-color);\n  background-color: var(--ring-sidebar-background-color);\n}\n\n.group {\n  width: 100%;\n\n  .groupName {\n    padding: calc(var(--ring-unit) * 1.25) calc(var(--ring-unit) * 1.5);\n\n    color: var(--ring-secondary-color);\n  }\n\n  .groupContent {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.item {\n  position: relative;\n  box-sizing: border-box;\n\n  display: flex;\n  align-items: center;\n\n  min-height: calc(6 * (var(--ring-unit)));\n  width: 100%;\n\n  padding: calc(0.75 * var(--ring-unit)) calc(2 * var(--ring-unit));\n\n  background-color: transparent;\n  transition: background-color var(--ring-fast-ease);\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -1px;\n    width: 2px;\n    height: 100%;\n    background-color: transparent;\n    transition: background-color var(--ring-fast-ease);\n  }\n\n  &.interactive {\n    cursor: pointer;\n  }\n\n  &.primary {\n    &.interactive:hover {\n      background-color: var(--ring-selected-background-color);\n    }\n\n    &.selected {\n      background-color: var(--ring-selected-background-color);\n\n      &:before {\n        background-color: var(--ring-action-link-color);\n      }\n    }\n  }\n\n  &.secondary {\n    &.interactive:hover {\n      background-color: var(--ring-border-disabled-color);\n    }\n\n    &.selected {\n      background-color: var(--ring-border-disabled-color);\n\n      &:before {\n        background-color: var(--ring-borders-color);\n      }\n    }\n  }\n}\n\n.listWrapper > .group {\n  &:last-child {\n    border-bottom-left-radius: var(--ring-border-radius);\n    border-bottom-right-radius: var(--ring-border-radius);\n  }\n}\n\n.listWrapper > .item {\n  &:first-child {\n    border-top-left-radius: var(--ring-border-radius);\n    border-top-right-radius: var(--ring-border-radius);\n\n    padding-top: calc(1.5 * var(--ring-unit));\n\n    &:before {\n      border-top-left-radius: var(--ring-border-radius);\n    }\n  }\n\n  &:last-child {\n    border-bottom-left-radius: var(--ring-border-radius);\n    border-bottom-right-radius: var(--ring-border-radius);\n\n    padding-bottom: calc(1.5 * var(--ring-unit));\n\n    &:before {\n      border-bottom-left-radius: var(--ring-border-radius);\n    }\n  }\n}\n\n.group:last-child .groupContent > .item {\n  &:last-child {\n    border-bottom-left-radius: var(--ring-border-radius);\n    border-bottom-right-radius: var(--ring-border-radius);\n\n    padding-bottom: calc(1.5 * var(--ring-unit));\n\n    &:before {\n      border-bottom-left-radius: var(--ring-border-radius);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listWrapper": `listWrapper__a79`,
	"group": `group__c2e`,
	"groupName": `groupName__c0e`,
	"groupContent": `groupContent__d10`,
	"item": `item__b78`,
	"interactive": `interactive__d18`,
	"primary": `primary__f67`,
	"selected": `selected__c64`,
	"secondary": `secondary__a0a`
};
export default ___CSS_LOADER_EXPORT___;
